import React, {useState} from 'react';
import { connect, useDispatch } from 'react-redux';
import ErrorAlert from '../Alerts/ErrorAlert';
import { closeModal } from '../../store/modal/actions';
import AuthService from '../../services/auth';
import x from '../../assets/static/Modals/x.png';
import useCurrentLanguage from "../../services/currentlenguaje";
import modalsJson from "./tradModals.json"

const RecoverModal = ({closeModal}) => {
  const { handleFilterLang } = useCurrentLanguage();

    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [errorInput, setErrorInput] = useState('');
    const [hideEmail, setHideEmail] = useState(false);
    const dispatch = useDispatch();
    const handleModalContainerClick = e => e.stopPropagation();
    const ifValidate = (input) => {
        if(input === "email" || input=== undefined){
            if(email.length < 5){
                return {v:false, e:

          handleFilterLang(modalsJson).mailValido
          ,i:'email'}
            }
            // eslint-disable-next-line no-useless-escape
            let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if(email.length > 5){
                if(!re.test(email)){
                    return {v:false, e:
          handleFilterLang(modalsJson).mailInvalido
                        , i:'email'}
                }
            }
        }
        return {v:true, e:"", i:''}
    }

    const handleValidate = (input) =>{
        const _ifValidate = ifValidate(input);
        if(!_ifValidate.v){
            setErrorInput(_ifValidate.i)
            setError(_ifValidate.e)
        }
    }

    const handleSubmit = (evt) => {

        evt.preventDefault();

        const _ifValidate = ifValidate();
        if(_ifValidate.v){
            AuthService.recover(email)
            .then(function (response) {
                setError(
          handleFilterLang(modalsJson).envioMail
          )
                setHideEmail(true)
            })
            .catch(function (error) {
                console.log(error.response)
                if(error.response.status === 404){
                    setError(
          handleFilterLang(modalsJson).mailNoRegistrado
                        )
                }else{
                    setError(error.response)
                }
            });
        }else{
            setErrorInput(_ifValidate.i)
            setError(_ifValidate.e)
        }
    }

    return(
        <div className="recover_modal" onClick={closeModal}>
            <header >
          {handleFilterLang(modalsJson).pregOlvidasteContraseña}

                <img style={{height:"30px",width:"30px", top:"3px",right:"10px"}}  src={x} alt="Close Modal" className="x" onClick={() => dispatch(closeModal()) }/> 
            </header>
            <section onClick={handleModalContainerClick}>
                <form onSubmit={handleSubmit}>
                <p className="mensaje">
          {handleFilterLang(modalsJson).TeEnviamosMailREseteo}
          </p>
                {
                    (error)
                    ? <ErrorAlert message={error} />
                    : ''
                }
                {
                    hideEmail ? ''
                                :
                        <div>
                            <div className="input_continer">
                                <div className={errorInput === 'email' ? "input_wrapper error recover_wrapper": "input_wrapper recover_wrapper"}>
                                        <label>E-MAIL</label>
                                        <input 
                                            type="email" 
                                            placeholder="Escribe tu e-mail"
                                            value={email}
                                            onChange={e => setEmail(e.target.value)}
                                            onBlur={()=>handleValidate('email')}
                                        />
                                </div>
                            </div>

                            <button type="submit" className="button_orange">
          {handleFilterLang(modalsJson).enviarCodigo}
          </button>
                        </div>
                }
                
                
                </form>
            </section>
        </div>
    );
}

export default connect(null,{closeModal})(RecoverModal);
